export const achievementsByPass = {
    elements: []
}
